// removed by extract-text-webpack-plugin
module.exports = {"root":"cms__ObjectControl__root"};


//////////////////
// WEBPACK FOOTER
// ./components/Widgets/ObjectControl.css
// module id = 561
// module chunks = 0